import Api from "./Api";
import { GetCookie } from "@/utils/CookieUtil";
const novaPalestra = (formData) => {
  const form = new FormData();
  form.append("title", formData.title);
  form.append("description", formData.description);
  form.append("speaker", formData.speaker);
  form.append("ytURL", formData.ytURL);
  form.append("date", formData.date);
  form.append("hour", formData.hour);
  form.append("hourEnding", formData.hourEnding);
  form.append("photo", formData.photo);
  return Api().post("/palestras", form);
};

const getAoVivo = () => {
  return Api().get("/palestras/ao-vivo");
};

const listarPalestras = (dia) => {
  return Api().get("/palestras", { params: { dia } });
};

const palestraById = (idPalestra) => {
  return Api().get(`/palestras/${idPalestra}`);
};

const updatePalestra = (formData) => {
  const form = new FormData();
  form.append("id", formData._id);
  form.append("title", formData.title);
  form.append("description", formData.description);
  form.append("speaker", formData.speaker);
  form.append("ytURL", formData.ytURL);
  form.append("date", formData.date);
  form.append("hour", formData.hour);
  form.append("hourEnding", formData.hourEnding);
  form.append("photo", formData.photo);
  return Api().patch(`/palestras`, form);
};

const listarInscritos = (idPalestra) => {
  return Api().get(`/palestras/${idPalestra}/inscricoes`);
};

const excluirPalestra = (idPalestra) => {
  return Api().delete(`/palestras/${idPalestra}`);
};

const exportarInscritosPalestra = (idPalestra) => {
  return Api().get(`/exportar/inscritos-palestras/${idPalestra}?token=${GetCookie("token")}`)
};

export {
  novaPalestra,
  listarPalestras,
  listarInscritos,
  excluirPalestra,
  palestraById,
  updatePalestra,
  getAoVivo,
  exportarInscritosPalestra
};
